/* eslint-disable import/no-named-as-default-member */
import _ from 'lodash';
import { createSortText } from 'aegion_common_utilities/lib/Sort';

import DDB_CUSTOMERS from '../../Sync/DdbCustomers/selectors';

import PSQL_APPLICATIONS from '../../Sync/PsqlCustomersApplications/selectors';

import DDB_ENTITIES from '../../Sync/DdbCustomersEntities/selectors';
import PSQL_ENTITIES from '../../Sync/PsqlCustomersEntities/selectors';

import DDB_SETTINGS from '../../Sync/DdbCustomersSettings/selectors';
import { goodEnoughUUID } from '../../../../../scanline/utils/uuid';
import { cleanName } from '../../../../api/util/customer';

const createApplicationsMap = (stateAdmin, customerName) => {
	const psqlAppMap = PSQL_APPLICATIONS.selectBoolMapByCustomer(stateAdmin, {
		customer: customerName
	});

	return { ...psqlAppMap };
};

const createEntityObject = ({ name = '', active = true, isNew } = {}) => {
	const result = {
		clientId: goodEnoughUUID(),
		name,
		newName: undefined,
		active
	};
	if (isNew) {
		result.isNew = true;
	}
	return result;
};

const sortEntities = createSortText('ASC', {
	caseSensitive: false
});

const createEntitiesArray = (stateAdmin, customerName) => {
	const ddbEntitiesMap = DDB_ENTITIES.selectBoolMapByCustomer(stateAdmin, {
		customer: customerName
	});
	const psqlEntitiesMap = PSQL_ENTITIES.selectBoolMapByCustomer(stateAdmin, {
		customer: customerName
	});

	const entitiesMap = { ...ddbEntitiesMap, ...psqlEntitiesMap };
	const keys = Object.keys(entitiesMap).sort(sortEntities);
	return keys.reduce((acc, k) => {
		acc.push(
			createEntityObject({
				name: k,
				active: !!entitiesMap[k]
			})
		);
		return acc;
	}, []);
};

const createSettingsMap = (stateAdmin, customerName) => {
	const settings = DDB_SETTINGS.selectDataByCustomer(stateAdmin, {
		customer: customerName
  });

	return _.cloneDeep(settings);
};

/* eslint-disable import/prefer-default-export */
const createCustomerObject = (stateAdmin, customerName) => {
	return {
		name: customerName,
		domain: DDB_CUSTOMERS.selectDomain(stateAdmin, { customer: customerName }),
		applications: createApplicationsMap(stateAdmin, customerName),
		entities: createEntitiesArray(stateAdmin, customerName),
		settings: createSettingsMap(stateAdmin, customerName)
	};
};

const overWriteAssetViewSettings = (
	selectedCustomerChangesClone,
	defaultMatchTerm
) => {
	const obj = selectedCustomerChangesClone;
	const avAppkeys = ['ASSETVIEW', 'ASSETVIEW®', 'AV', 'CORRMONITOR', 'CorrMonitor'];
	const PRIMARY_KEY = 'ASSETVIEW';
	const SETTINGS = (obj?.settings || {})[PRIMARY_KEY] || {};

	avAppkeys.forEach(appKey => {
		obj.settings[appKey] = {...SETTINGS};
		if (!obj.settings[appKey].elasticsearchKeyMatcher) {
			if (defaultMatchTerm) {
				obj.settings[appKey].elasticsearchKeyMatcher = defaultMatchTerm;
			} else {
				obj.settings[appKey].elasticsearchKeyMatcher = cleanName(obj.name);
			}
		}
	})
};

const overWriteScanlineSettings = (
	selectedCustomerChangesClone
) => {
	const obj = selectedCustomerChangesClone;
	const appkeys = ['SCANLINE', 'SCANLINE®', 'SL', 'CORRLOGIX', 'CorrLogix'];
	const PRIMARY_KEY = 'SCANLINE';
	const SETTINGS = (obj?.settings || {})[PRIMARY_KEY] || {};

	appkeys.forEach(appKey => {
		obj.settings[appKey] = {...SETTINGS};
	})
};

const enableAssetViewSettings = (selectedCustomerChangesClone, enable) => {
	const obj = selectedCustomerChangesClone;
	const avAppkeys = ['ASSETVIEW', 'ASSETVIEW®', 'AV', 'CORRMONITOR', 'CorrMonitor'];
	avAppkeys.forEach(appKey => {
		obj.settings[appKey].enabled = !!enable;
  });
};

export {
	createEntityObject,
	createCustomerObject,
	overWriteAssetViewSettings,
	overWriteScanlineSettings,
	enableAssetViewSettings
};
